import React from 'react';

const SessionsList = ({ 
  unitId, 
  unitName, 
  projects, 
  selectedProject, 
  setSelectedProject,
  sessions, 
  isLoadingSessions, 
  selectedSession, 
  setSelectedSession,
  onDownloadProject,
  onDownloadSession 
}) => {
  return (
    <div className="left-panel">
      <div className="unit-info">
        <h4>Unit Information</h4>
        <p><strong>Name:</strong> {unitName || 'N/A'}</p>
        <p><strong>Unit ID:</strong> {unitId}</p>
        <p>{projects.length} projects</p>
      </div>
      
      {projects.length > 0 && (
        <div className="project-selector project-info">
          <h4>Project</h4>
          <select 
            value={selectedProject || ''} 
            onChange={(e) => setSelectedProject(e.target.value)}
            style={{
              width: '100%',
              padding: '8px',
              marginBottom: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          >
            {projects.map((project) => (
              <option key={project.folder} value={project.folder}>
                {project.name}
              </option>
            ))}
          </select>
          {selectedProject && (
            <div>
              {sessions && (
                <p className="d-inline">{sessions.length} sessions</p>
              )}
              <i 
                className="fa-solid fa-cloud-arrow-down download-icon ml-2"
                onClick={onDownloadProject}
                title="Download entire project"
                style={{ fontSize: '20px', marginTop: '8px', cursor: 'pointer' }}
              />
            </div>
          )}
        </div>
      )}
      
      <div className="sessions-section">
        <h4>Sessions</h4>
        <div className="sessions-list">
          {isLoadingSessions ? (
            <div className="loading-container">
              <div className="spinner" />
              <p>Loading sessions...</p>
            </div>
          ) : sessions && sessions.length > 0 ? (
            sessions.map((session, index) => (
              <div 
                key={session.sessionId || `session-${index}`} 
                className={`session-item ${selectedSession === session.sessionId ? 'selected' : ''}`}
                onClick={() => setSelectedSession(session.sessionId)}
              >
                {session.thumbnail && (
                  <img 
                    src={`${process.env.REACT_APP_BASE_URL}${session.thumbnail}`}
                    alt="Session thumbnail"
                    className="session-thumbnail"
                    onError={(e) => e.target.style.display = 'none'}
                  />
                )}
                <div className="session-info">
                  <div className="session-date">{session.date}</div>
                  <div className="session-time">{session.time}</div>
                  {session.duration && <div className="session-duration">{session.duration}</div>}
                </div>
                <i 
                  className="fa-solid fa-cloud-arrow-down download-icon"
                  onClick={(e) => onDownloadSession(session.sessionId, e)}
                  title="Download session"
                />
              </div>
            ))
          ) : (
            <p className="no-sessions">No sessions found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SessionsList;